import axios from 'axios';
import Config from '../actions/Config';
import AccessToken from '../actions/AccessToken';

const BASE_URL = Config();
const getProfile = {};
const token = AccessToken();

getProfile.ProfileInfo = (endpoint, accessToken, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accessToken}` },
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        console.log(error);
    })
} 
getProfile.GetUserList = (endpoint, accessToken, callback) => {
    axios({  
    method: 'GET',   
    url: `${BASE_URL}${endpoint}`,   
    headers: { Authorization: `Bearer ${accessToken}` },  
    })
    .then(function(response) { 
        callback(response);
    })   
    .catch(function(error) {   
        callback(error.response);
    })  
}
getProfile.GetRole = (endpoint, accesstoken, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` },
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);
    })
} 
getProfile.CreateNewUser = (endpoint, accesstoken, details, callback) => {
    axios({    
    method: 'POST',    
    url: `${BASE_URL}${endpoint}`,    
    headers: { Authorization: `Bearer ${accesstoken}` },    
    data: details    
    })    
    .then(function(response) {   
        callback(response);  
    })    
    .catch(function(error) {   
        console.log(error);    
        callback(error.response);   
    })   
}
getProfile.EditProfile = (data, endpoint, accessToken, callback) => {
    axios({
        method: 'POST',
        url: `${BASE_URL}${endpoint}`,
        data: data,
        headers: { Authorization: `Bearer ${accessToken}` },
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        console.log(error);
        callback(error.response);   
    })
} 
getProfile.Profileupload = (endpoint, data, accessToken, callback) => {
    axios({
        method: 'POST',
        url: `${BASE_URL}${endpoint}`,
        data: data,
        headers: { Authorization: `Bearer ${accessToken}` },
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        console.log(error);
        callback(error.response);   
    })
} 
getProfile.GetUserDetails = (endpoint, accesstoken, callback) => {
    axios({  
    method: 'GET',   
    url: `${BASE_URL}${endpoint}`,   
    headers: { Authorization: `Bearer ${accesstoken}` },  
    })
    .then(function(response) { 
        callback(response);
    })   
    .catch(function(error) {   
        console.log(error); 
        callback(error.response);      
    })  
}
getProfile.EditUser = (endpoint, accesstoken, details, callback) => {
    axios({
        method: 'POST',
        url: `${BASE_URL}${endpoint}`,
        data: details,
        headers: { Authorization: `Bearer ${accesstoken}` },
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        console.log(error);
        callback(error.response);   

    })
}
getProfile.DeleteRole = (endpoint, accessToken, callback) => {
    axios({
        method: 'POST',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accessToken}` },
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        console.log(error);
        callback(error.response);   
    })
}
getProfile.DeleteUser = (endpoint, accesstoken, callback) => {
    axios({
        method: 'POST',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` },
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        console.log(error);
        callback(error.response);   
    })

} 
getProfile.EditAddContact = (endpoint, data, accessToken, callback) => {
    axios({
        method: 'POST',
        url: `${BASE_URL}${endpoint}`,
        data: data,
        headers: { Authorization: `Bearer ${accessToken}` },
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        console.log(error);
        callback(error.response);   
    })
}
getProfile.SuspendUser = (endpoint, accesstoken, callback) => {
    axios({
        method: 'POST',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` },
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);   
    })
}
getProfile.ResetPassword = (endpoint, accesstoken, details, callback) => {
    axios({
        method: 'POST',
        url: `${BASE_URL}${endpoint}`,
        data: details,
        headers: { Authorization: `Bearer ${accesstoken}` },
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        console.log(error);
        callback(error.response);   
    })
}


export default getProfile;
